export const discountPercent = (code, customerDiscounts) => {
  return new Promise((resolve, reject) => {
    customerDiscounts.getCustomerDiscountPercent(code)
      .then(response => {
        resolve({
          percentage: response.data.percentage
        });
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
}

export const getPriceWithDiscount = (price, percentage) => {
  // const multiplier = (100 + parseFloat(percentage)) / 100;
  const discount = (Math.floor((price * percentage) * 100) / 100)
  return (price - discount).toFixed(2);
}


export const getPriceWithCurrencySign = (price) => {
  const currencyCode = window.ShopifyAnalytics?.meta?.currency;

  if (currencyCode === 'GBP') {
    return "£" + price;
  }
  if (currencyCode === 'PLN') {
    return price + ' zł';
  }
  return "€" + price;
}